export default __webpack_public_path__ + "static/nigel-579acb1d999aa3fdc3d008abd40ce692.jpg";